import React from "react"

import { Logger } from "shared/lib/Logger"
import { WebsocketConnectionState } from "shared/types/websocket/WebsocketConnectionState"

import { ProjectCollaborationMessage } from "./ProjectCollaborationEvent"

export interface ProjectCollaborationContextType {
  subscribe: (
    projectID: string,
    subscriptionID: string,
    options: { onMessage: (event: ProjectCollaborationMessage) => void }
  ) => () => void
  connectionState: WebsocketConnectionState
}

export const ProjectCollaborationContext =
  React.createContext<ProjectCollaborationContextType>({
    subscribe: () => {
      Logger.error("MissingContextError", "Missing ProjectCollaborationContext")
      return () => {}
    },
    connectionState: WebsocketConnectionState.UNINSTANTIATED
  })
